/**
 * Language configuration.
 *
 * English is the default and lives at the unprefixed path. Turkish lives under
 * /tr. There is deliberately no automatic redirect based on browser language:
 * the site opens in English, the switcher is visible, and an explicit choice is
 * remembered.
 */

export const LANGUAGES = {
  en: { code: "en", label: "English", short: "EN", htmlLang: "en", locale: "en-US" },
  tr: { code: "tr", label: "Türkçe", short: "TR", htmlLang: "tr", locale: "tr-TR" },
};

export const DEFAULT_LANG = "en";
export const LANG_CODES = Object.keys(LANGUAGES);

/** URL segment for each non-default language. */
export const LANG_PREFIX = { tr: "/tr" };

export const STORAGE_KEY = "preferredLanguage";

/**
 * Hides the header switcher while the translations are still being filled in.
 * Routes under /tr work regardless, so the work can be reviewed before it is
 * announced to visitors.
 */
export const LANGUAGE_SWITCHER_ENABLED = true;

/** Paths that are never localized: internal tooling and the standalone apps. */
export const UNLOCALIZED_PREFIXES = ["/admin", "/english-time", "/tuba-admin"];
